import React, { useEffect } from 'react';
import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import { Feedback } from 'containers';
import { checkIsLoggedIn } from 'utils/CommonUtil';

const FeedBack = props => {
	useEffect(() => {
		// gtmTrackPage(gaPageTrackTags.welcomePage);
		checkIsLoggedIn(props);
	}, [props]);

	return (
		<Fabric>
			<Feedback {...props} />
		</Fabric>
	);
};

export default FeedBack;
